import React, { useState, useEffect } from 'react';
import { IonRow, IonCol } from '@ionic/react';
import './MopFooterMenuItem.scss';
import { ApplicationState } from '../store';
import * as currencyHelpers from '../helpers/currencyHelpers';
import { useHistory } from "react-router-dom";

import { useSelector, useDispatch } from 'react-redux';
import * as basketStore from '../store/BasketStore';
import { bindActionCreators } from 'redux';

import { simpleChannelType } from '../store/LocationStore';
import Button from './Button';

const MopFooterMenuItem: React.FC = () => {
    const locationState = useSelector((state: ApplicationState) => state.location);
    const isBasket = useSelector((state: ApplicationState) => state.menuItemData?.isBasket);
    const menuItem = useSelector((state: ApplicationState) => state.menuItemData?.menuItem);
    const totalPrice = useSelector((state: ApplicationState) => state.menuItemData?.menuItem?.menuItemTotalPrice);
    const boundAddToBasket = bindActionCreators(basketStore.actionCreators.addMenuItemToBasket, useDispatch());
    const boundUpdateBasket = bindActionCreators(basketStore.actionCreators.updateBasketItem, useDispatch());

    const history = useHistory();
    const [price, setPrice] = useState("");
    const [enableButton, setEnableButton] = useState(false);

    const handleClick = () => {
        if (!isBasket) {
            boundAddToBasket();
        } else {
            boundUpdateBasket();
        }

        history.goBack();
    }

    useEffect(() => {
        setPrice(currencyHelpers.formatCurrency(totalPrice));
    }, [totalPrice]);

    useEffect(() => {
        const canAddOrUpdate = menuItem?.modifierGroups
            .every((group: IMopModifierGroup) => {
                if (group.groupType === 10) {
                    return group.modifierGroupItems.some((item: IMopModifierGroupItem) => (
                        item.quantitySelected > 0
                    ));
                }

                if (group.itemsAreChargeable === false && group.maxDifferentItems > 1) {
                    return group.modifierGroupItems.reduce((acc: number, item: IMopModifierGroupItem) => (
                        acc + item.quantitySelected
                    ), 0) === group.maxDifferentItems;
                }

                return true;
            }) ?? false;

        let hasPriceSet = (totalPrice ?? 0) > 0;

        setEnableButton(canAddOrUpdate && hasPriceSet);
    }, [menuItem?.modifierGroups, totalPrice]);

    return (
        <div className="MopFooterInner">
            {menuItem &&
                <IonRow className="ion-align-items-center">
                    <IonCol size="4" className="FooterStoreWrapper">
                        <span className="CollectFrom">{locationState?.selectedChannel === undefined ? "Store" : locationState.selectedChannel.channelType === simpleChannelType.ClickAndCollect ? "Take away" : "Eat in"}</span><br />
                        <span className="Location">{locationState?.selectedStore === undefined ? "Select a store" : locationState?.selectedStore.storeName}</span>
                        {locationState?.selectedStore?.takingMopOrders === false ? <span style={{ color: "#ff0" }}> - Order ahead not available</span> : null}
                    </IonCol>
                    <IonCol size="8">
                        <Button
                            onClick={handleClick}
                            disabled={!enableButton}
                            expand="block"
                            size="small"
                            color="secondary"
                            rounded
                        >
                            {isBasket ? "Update Item" : "Add to Order"}
                            {(totalPrice ?? 0) > 0 &&
                                <span>&nbsp;-&nbsp;{price}</span>
                            }
                        </Button>
                    </IonCol>
                </IonRow>
            }
        </div>
    );
};

export default MopFooterMenuItem;
